@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';

.clear-indicator {
  // hide by default, show on hover or focus
  display: none;
}

.indicator-separator {
  // hide by default, show on hover or focus
  display: none;
}

.show-clear-button {
  .clear-indicator {
    display: flex;
  }

  .indicator-separator {
    display: block;
  }
}

.input {
  margin: 0;
  padding: 0;
}

.base-combobox {
  cursor: pointer;
  border: solid 1px var(--default--border-color--5);
  border-radius: 4px;
  min-height: 30px;
  font-size: 14px;
  line-height: 24px;

  // react-select adds a box-shadow on focus, this overrides it so we can apply our own style using outline
  box-shadow: none;

  &.has-error {
    border-color: var(--input-v2-INTERNAL--error--border-color);
  }

  &:hover {
    .show-clear-button();
    border-color: var(--gray-56595D);
  }

  &:active {
    border-color: var(--blue-11003A);
  }

  &.is-focused {
    .show-clear-button();

    border-color: var(--primary--focus--border-color--3);
    // overrides !important in internal react-select styles
    outline: rgba(0, 111, 187, 0.33) solid 2px !important;
    outline-offset: 2px;
  }

  &.is-open {
    .show-clear-button();
    border-color: var(--blue-11003A);
    // overrides !important the above override :)
    outline: none !important;
  }
}

.menu {
  margin: 5px 0;
  box-shadow: 0 2px 2px 0 rgba(39, 41, 42, 0.24);
  background: var(--light--background-color--1);
}

.menu-full-width {
  min-width: max-content;
}

.menu-list {
  padding: 0;
}

.indicators-container {
  height: 30px;
}

.value-container {
  padding: 0 0 0 @space-8;
}

.option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: @space-8;
  border: 1px solid transparent;
  border-radius: 0;
  padding: @space-4 @space-16;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  color: var(--gray-0F0F10);
  background: @dropdown-menu-item--background-color;

  &.is-disabled {
    cursor: default;
    color: @dropdown-menu-item--disabled--text-color;
    background: var(--gray-F1F2F3);
  }

  &.is-focused {
    background: @dropdown-menu-item--hover--background-color;
  }

  &.is-selected {
    font-weight: 500;
    color: var(--gray-0F0F10);
    background: @dropdown-menu-item--selected--background-color;
  }
}

.group {
  padding: 0;
}

.group-heading {
  padding: @space-4 @space-12;
  background: var(--gray-DFE4E8);
  color: var(--gray-0F0F10);
  margin: 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-transform: none;
}

.single-value {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: @space-8;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-required-wrapper {
  position: relative;
}
.required-indicator {
  position: absolute;
  top: 0;
  right: 0;
}
